module.exports = __webpack_public_path__ + "img/internet4.c4ef8798.png";